import center from "@turf/center"
import cleanCoords from "@turf/clean-coords"
import { Geometry } from "@turf/helpers"
import _ from "lodash"
import turfLineOffset from "@turf/line-offset"
import { lineString as turfLineString } from "@turf/helpers"

// Calculates the center point of a GeoJSON geometry and Return as a Coordinates.
export const getCenterFromGeometry = (geometry?: Geometry): number[] | null => {
  try {
    const { type = null, coordinates = null } = geometry
    if (!type || !coordinates) return null
    const centerPoint = center(geometry)
    return _.get(centerPoint, "geometry.coordinates") // Coordinates
  } catch (error) {
    return null
  }
}

export const createPolygonFromLineString = (geometry) => {
  const line = turfLineString(geometry.coordinates)
  const cleanedLine = cleanCoords(line)
  const left = turfLineOffset(cleanedLine, 0.3, { units: "meters" })
  const right = turfLineOffset(cleanedLine, -0.3, { units: "meters" })
  const leftCoords = left.geometry.coordinates
  const rightCoords = right.geometry.coordinates.reverse()
  const polygon = [...leftCoords, ...rightCoords, leftCoords[0]]
  return [polygon]
}
